import { memo, useState } from "react";
import { Button } from "primereact/button";
import { Chart } from "primereact/chart";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default memo(function ChartQuebras({ data, printing, handlePrint, producoes, index, type }) {
    const [order, setOrder] = useState('none');

    const orderLabels = {
        "none": "Normal",
        "asc": "Crescente",
        "desc": "Decrescente"
    }

    const options = {
        maintainAspectRatio: false, 
        plugins: {
            title: {
                display: true,
                text: 'Gráfico de Quebras de Trama por Tear - ' + String(type).charAt(0).toUpperCase() + String(type).slice(1) + ' - ' + data.periodo,
                font: {
                    size: 18
                }
            },
            datalabels: {
                align: 'end',
                anchor: 'end',
                formatter: (value, context) => {
                    return Intl.NumberFormat('pt-BR').format(value)
                },
                font: {
                    size: 20
                },
                color: "#2c3e50",
                rotation: -90
            }
        },
        scales: {
            x: {
              ticks: {
                font: {
                  size: 16
                },
                color: "#000"
              }
            },
        },
        responsive: true
    }

    let labels = [];
    let datasets = [];

    if (order === 'none') {
        producoes = producoes.sort((a, b) => {
            return a.tear - b.tear;
        });
    } else if (order === 'asc') {
        producoes = producoes.sort((a, b) => {
            return a[`${type}`] - b[`${type}`];
        });
    } else if (order === 'desc') {
        producoes = producoes.sort((a, b) => {
            return a[`${type}`] - b[`${type}`];
        }).reverse();
    }

    producoes.forEach(element => {
        labels.push(element.tear);
        datasets.push(element[`${type}`]);
    });

    const chartData = {
        labels: labels,
        datasets: [
            {
                label: 'Total',
                data: datasets,
                backgroundColor: '#2980b9'
            }
        ]
    }

    return (
        <div >
            <div className="p-d-flex p-flex-row p-ai-center">
                <Button className="p-ml-2" icon="pi pi-print" onClick={() => handlePrint(`chartQuebrasTear${index}`)} />
                <Button
                    className="p-ml-2 p-button-danger"
                    icon="pi pi-refresh"
                    onClick={() => {
                        if (order === 'none') {
                            setOrder('asc');
                        } else if (order === 'asc') {
                            setOrder('desc');
                        } else if (order === 'desc') {
                            setOrder('none');
                        }
                    }}
                />
                <span className="p-ml-2">{orderLabels[order]}</span>
            </div>
            <Chart
                id={`chartQuebrasTear${index}`}
                height={printing ? "205mm" : "850px"}
                width={printing ? "290mm" : "auto"}
                type="bar"
                data={chartData}
                plugins={[ChartDataLabels]}
                options={options}
            />
        </div>
    )
});